import React from "react";

export default function ForbiddenPage() {
  return (
    <div style={{ padding: 24 }}>
      <h2>403</h2>
      <p>No tienes permiso para ver esta página.</p>
    </div>
  );
}
